import { configureStore } from '@reduxjs/toolkit';
import tagsReducer from '@/state/tags/slice';

export const store = configureStore({
  reducer: {
    tags: tagsReducer,
  },
});

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;